import { render, staticRenderFns } from "./limitedUpgradeTool.vue?vue&type=template&id=2ba0e2d4&scoped=true"
import script from "./limitedUpgradeTool.vue?vue&type=script&lang=js"
export * from "./limitedUpgradeTool.vue?vue&type=script&lang=js"
import style0 from "./limitedUpgradeTool.vue?vue&type=style&index=0&id=2ba0e2d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba0e2d4",
  null
  
)

export default component.exports